document.addEventListener('click', (event) => {
  const swatch = event.target.closest('.merelle-card-swatch');
  if (!swatch || swatch.classList.contains('is-unavailable')) return;

  const group = swatch.closest('[data-merelle-card-swatches]');
  const card = swatch.closest('.card-wrapper');
  if (!group || !card) return;

  event.preventDefault();
  group.querySelectorAll('.merelle-card-swatch').forEach((item) => item.setAttribute('aria-pressed', item === swatch ? 'true' : 'false'));

  const primaryImage = card.querySelector('.card__media .media img:first-child');
  if (primaryImage && swatch.dataset.imageSrc) {
    primaryImage.src = swatch.dataset.imageSrc;
    primaryImage.srcset = swatch.dataset.imageSrcset || '';
  }

  if (swatch.dataset.variantUrl) {
    card.querySelectorAll('a[href*="/products/"]').forEach((link) => { link.href = swatch.dataset.variantUrl; });
    const quickAdd = card.querySelector('[data-product-url]');
    if (quickAdd) quickAdd.dataset.productUrl = swatch.dataset.variantUrl;
  }

  const price = card.querySelector('.price');
  if (!price) return;
  const salePrice = price.querySelector('.price__sale .price-item--sale');
  const oldPrice = price.querySelector('.price__sale .price-item--regular');
  const regularPrice = price.querySelector('.price__regular .price-item--regular');
  const comparePrice = swatch.dataset.comparePrice;

  if (comparePrice) {
    price.classList.add('price--on-sale');
    if (salePrice) salePrice.textContent = swatch.dataset.price;
    if (oldPrice) oldPrice.textContent = comparePrice;
  } else {
    price.classList.remove('price--on-sale');
    if (regularPrice) regularPrice.textContent = swatch.dataset.price;
  }
});
